import type { TourStep } from '../types';

export const mileageSetupSteps: TourStep[] = [
  {
    target: '[data-tour="mileage-settings"]',
    title: 'Configure Mileage Settings',
    content:
      'Before generating reports, set your home office address — this is the starting point for all trip calculations. Click into the settings to set it up.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve set my address',
  },
  {
    target: '[data-tour="mileage-settings"]',
    title: 'Vehicle & IRS Rate',
    content:
      'Optionally set your vehicle details and fuel cost per gallon. The IRS standard mileage rate for the current tax year is applied automatically.',
    placement: 'bottom',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="mileage-controls"]',
    title: 'Sync Controls',
    content:
      'Scout Mode and the Sync button live here. Syncing reconstructs trips from your completed inspections — days you have already built are reused from cache, so re-running is fast and only new days use routing credits.',
    placement: 'bottom',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="mileage-scout"]',
    title: 'Scout Mode',
    content:
      'Enable this to include a separate pre-inspection scouting trip for each property. Many appraisers drive by the neighborhood before the official inspection — this captures that mileage.',
    placement: 'bottom',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="mileage-generate"]',
    title: 'Sync Your Ledger',
    content:
      'Click Sync to reconstruct driving history for the selected view. Ashlar uses your completed inspection dates and property addresses to calculate round-trip mileage from your office.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'Sync',
  },
];
